import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-toolbar2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ServiceLevelAgreementServiceCategoryChangeDialog {
    Bao = Bao;
    Parent: any;
    TabPage: TabPage;
    Dialog = new BaoDialog(Bao.Session.ApplicationName);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    ChangeAllServices = ko.observable("0");
    Years: KnockoutObservableArray<number> = ko.observableArray([2010, 2011, 2012, 2013]);
    Months: KnockoutObservableArray<number> = ko.observableArray([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    Year: KnockoutObservable<number | string> = ko.observable(null);
    Month: KnockoutObservable<number | string> = ko.observable(null);
    constructor(tabPage: TabPage, parent: any) {
        this.TabPage = tabPage;
        this.Parent = parent;
        //this.Dialog.Width("750px");
        this.Dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgApply"),
                Click: () => {
                    this.DialogResult(true);
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    this.DialogResult(false);
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { }
            }
        ]);
        this.ChangeAllServices.subscribe((newValue) => {
            if (newValue == "0") {
            }
            else {
            }
        });
    }
    Amount = ko.observable<number>();
    Tarif = ko.observable<number>();
    Sla = ko.observable<string>();
    NumberBoxAmount: Bindings.baoNumberBox = {
        value: this.Amount,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxTarif: Bindings.baoNumberBox = {
        value: this.Tarif,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    Show(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId, serviceLevelAgreementTypeName) {
        this.TabPage.IsLoading(true);
        this.Sla(serviceLevelAgreementTypeName);
        Bao.post("ServiceLevelAgreementTab/ShowServiceLevelAgreementServiceCategoryChangeDialog", JSON.stringify({
            sessionTabId: this.Parent.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementServiceCategoryId: serviceLevelAgreementServiceCategoryId
        }), (value) => {
            ko.map.fromJS(value.Model, this);
            //this.Dialog = new BaoDialog(this.GetDialogTitle());
            this.Dialog.ViewModel(this);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
            this.TabPage.IsLoading(false);
        });
    }
    ;
    /**
    * Gets DialogTempalte
    * returns JQueryPromise<string> with the template in it
    */
    GetDialogTemplate(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        return Bao.post("ServiceLevelAgreementTab/ShowServiceLevelAgreementServiceCategoryChangeDialog", JSON.stringify({
            sessionTabId: this.Parent.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementServiceCategoryId: serviceLevelAgreementServiceCategoryId
        }), (value) => {
            ko.map.fromJS(value.Model, this);
            return value.Message;
        });
    }
    GetDialogTitle() {
        return "Hallo";
    }
    /**
 * Open this as Bao-Dialog
 * @returns promise which is resolved when dialog is closed.
 */
    Open(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        let def = $.Deferred<boolean>();
        this.TabPage.IsLoading(true);
        this.GetDialogTemplate(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId)
            .then((htmlDialogTemplate: string) => {
            this.Dialog = new BaoDialog(this.GetDialogTitle());
            this.Dialog.ViewModel(this);
            this.Dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        this.Dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                }
            ]);
            this.Dialog.Closed = () => {
                // resolve Opens returned promise
                def.resolve(true);
            };
            this.Dialog.Template(htmlDialogTemplate);
            // last open dialog and set is loading to false
            this.Dialog.Open();
            //this.Refresh().then(() => {
            this.TabPage.IsLoading(false);
            //});
        });
        return def.promise();
    }
    loaded() {
    }
    init(): JQueryPromise<any> {
        var def = $.Deferred();
        Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    this.Years.push(result[r].Key);
            }
            this.Year(JahrAkt);
            def.resolve();
            //});
        });
        return def.promise();
    }
}
export default ServiceLevelAgreementServiceCategoryChangeDialog;